import SectionTitle from "../../components/common/SectionTitle/SectionTitle";

import "./PageLayout.scss";

const PageLayout = ({ title, subtitle, actions, children }) => {
    return (
        <div className="page-container">
            <SectionTitle title={title} subtitle={subtitle} actions={actions} />

            <div className="page-content">{children}</div>
        </div>
    );
};

export default PageLayout;
